@file:OptIn(InternalResourceApi::class)

package swetgram.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/swetgram.shared.generated.resources/"

@delegate:ResourceContentHash(-1_091_902_159)
internal val Res.string.premium_badge_description: StringResource by lazy {
      StringResource("string:premium_badge_description", "premium_badge_description", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 110, 77),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 94, 69),
      ))
    }

@delegate:ResourceContentHash(696_315_892)
internal val Res.string.premium_badge_setting: StringResource by lazy {
      StringResource("string:premium_badge_setting", "premium_badge_setting", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 379, 81),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 307, 53),
      ))
    }

@delegate:ResourceContentHash(809_844_612)
internal val Res.string.premium_badge_setting_body: StringResource by lazy {
      StringResource("string:premium_badge_setting_body", "premium_badge_setting_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 188, 190),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 164, 142),
      ))
    }

@delegate:ResourceContentHash(1_605_008_142)
internal val Res.string.premium_billing_acknowledgement_pending: StringResource by lazy {
      StringResource("string:premium_billing_acknowledgement_pending", "premium_billing_acknowledgement_pending", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 461, 219),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 361, 155),
      ))
    }

@delegate:ResourceContentHash(875_231_043)
internal val Res.string.premium_billing_already_active: StringResource by lazy {
      StringResource("string:premium_billing_already_active", "premium_billing_already_active", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 681, 226),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 517, 146),
      ))
    }

@delegate:ResourceContentHash(1_102_257_670)
internal val Res.string.premium_billing_no_purchase: StringResource by lazy {
      StringResource("string:premium_billing_no_purchase", "premium_billing_no_purchase", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 908, 183),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 664, 127),
      ))
    }

@delegate:ResourceContentHash(-1_349_978_829)
internal val Res.string.premium_billing_pending: StringResource by lazy {
      StringResource("string:premium_billing_pending", "premium_billing_pending", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 1092, 203),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 792, 143),
      ))
    }

@delegate:ResourceContentHash(-2_038_443_307)
internal val Res.string.premium_billing_restored: StringResource by lazy {
      StringResource("string:premium_billing_restored", "premium_billing_restored", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 1296, 104),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 936, 92),
      ))
    }

@delegate:ResourceContentHash(-661_672_234)
internal val Res.string.premium_billing_unavailable: StringResource by lazy {
      StringResource("string:premium_billing_unavailable", "premium_billing_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 1401, 215),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 1029, 123),
      ))
    }

@delegate:ResourceContentHash(678_787_276)
internal val Res.string.premium_billing_verification_failed: StringResource by lazy {
      StringResource("string:premium_billing_verification_failed", "premium_billing_verification_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 1617, 259),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 1153, 159),
      ))
    }

@delegate:ResourceContentHash(-1_813_254_378)
internal val Res.string.premium_feature_limits: StringResource by lazy {
      StringResource("string:premium_feature_limits", "premium_feature_limits", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 2065, 82),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 1437, 50),
      ))
    }

@delegate:ResourceContentHash(-1_475_560_871)
internal val Res.string.premium_feature_limits_body: StringResource by lazy {
      StringResource("string:premium_feature_limits_body", "premium_feature_limits_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 1877, 187),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 1313, 123),
      ))
    }

@delegate:ResourceContentHash(2_051_219_945)
internal val Res.string.premium_feature_organization: StringResource by lazy {
      StringResource("string:premium_feature_organization", "premium_feature_organization", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 2354, 92),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 1622, 56),
      ))
    }

@delegate:ResourceContentHash(1_608_498_968)
internal val Res.string.premium_feature_organization_body: StringResource by lazy {
      StringResource("string:premium_feature_organization_body", "premium_feature_organization_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 2148, 205),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 1488, 133),
      ))
    }

@delegate:ResourceContentHash(1_392_054_975)
internal val Res.string.premium_feature_personalization: StringResource by lazy {
      StringResource("string:premium_feature_personalization", "premium_feature_personalization", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 2708, 91),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 1828, 51),
      ))
    }

@delegate:ResourceContentHash(-1_919_807_120)
internal val Res.string.premium_feature_personalization_body: StringResource by lazy {
      StringResource("string:premium_feature_personalization_body", "premium_feature_personalization_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 2447, 260),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 1679, 148),
      ))
    }

@delegate:ResourceContentHash(1_955_761_550)
internal val Res.string.premium_feature_profile: StringResource by lazy {
      StringResource("string:premium_feature_profile", "premium_feature_profile", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 3065, 103),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 2029, 55),
      ))
    }

@delegate:ResourceContentHash(1_038_628_734)
internal val Res.string.premium_feature_profile_body: StringResource by lazy {
      StringResource("string:premium_feature_profile_body", "premium_feature_profile_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 2800, 264),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 1880, 148),
      ))
    }

@delegate:ResourceContentHash(-892_795_474)
internal val Res.string.premium_grace: StringResource by lazy {
      StringResource("string:premium_grace", "premium_grace", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 3169, 137),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 2085, 89),
      ))
    }

@delegate:ResourceContentHash(-1_524_743_752)
internal val Res.string.premium_intro: StringResource by lazy {
      StringResource("string:premium_intro", "premium_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 3307, 305),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 2175, 165),
      ))
    }

@delegate:ResourceContentHash(993_291_603)
internal val Res.string.premium_legal: StringResource by lazy {
      StringResource("string:premium_legal", "premium_legal", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 3613, 293),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 2341, 169),
      ))
    }

@delegate:ResourceContentHash(-1_283_008_540)
internal val Res.string.premium_load_error: StringResource by lazy {
      StringResource("string:premium_load_error", "premium_load_error", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 3907, 98),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 2511, 66),
      ))
    }

@delegate:ResourceContentHash(-1_239_717_188)
internal val Res.string.premium_monthly: StringResource by lazy {
      StringResource("string:premium_monthly", "premium_monthly", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 4048, 43),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 2620, 35),
      ))
    }

@delegate:ResourceContentHash(1_843_091_331)
internal val Res.string.premium_monthly_price: StringResource by lazy {
      StringResource("string:premium_monthly_price", "premium_monthly_price", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 4006, 41),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 2578, 41),
      ))
    }

@delegate:ResourceContentHash(1_270_958_763)
internal val Res.string.premium_not_eligible: StringResource by lazy {
      StringResource("string:premium_not_eligible", "premium_not_eligible", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 4092, 220),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 2656, 160),
      ))
    }

@delegate:ResourceContentHash(-1_522_361_197)
internal val Res.string.premium_pending: StringResource by lazy {
      StringResource("string:premium_pending", "premium_pending", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 4313, 95),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 2817, 67),
      ))
    }

@delegate:ResourceContentHash(520_015_270)
internal val Res.string.premium_purchase_preparing: StringResource by lazy {
      StringResource("string:premium_purchase_preparing", "premium_purchase_preparing", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 4409, 90),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 2885, 74),
      ))
    }

@delegate:ResourceContentHash(1_311_676_263)
internal val Res.string.premium_restore: StringResource by lazy {
      StringResource("string:premium_restore", "premium_restore", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 4500, 75),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 2960, 47),
      ))
    }

@delegate:ResourceContentHash(1_796_747_229)
internal val Res.string.premium_retry: StringResource by lazy {
      StringResource("string:premium_retry", "premium_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 4576, 45),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 3008, 33),
      ))
    }

@delegate:ResourceContentHash(1_629_489_855)
internal val Res.string.premium_sales_closed: StringResource by lazy {
      StringResource("string:premium_sales_closed", "premium_sales_closed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 4622, 252),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 3042, 156),
      ))
    }

@delegate:ResourceContentHash(-1_909_492_672)
internal val Res.string.premium_settings_entry: StringResource by lazy {
      StringResource("string:premium_settings_entry", "premium_settings_entry", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 4875, 50),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 3199, 50),
      ))
    }

@delegate:ResourceContentHash(1_053_535_152)
internal val Res.string.premium_start_trial: StringResource by lazy {
      StringResource("string:premium_start_trial", "premium_start_trial", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 4926, 83),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 3250, 59),
      ))
    }

@delegate:ResourceContentHash(933_268_969)
internal val Res.string.premium_tagline: StringResource by lazy {
      StringResource("string:premium_tagline", "premium_tagline", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 5010, 87),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 3310, 51),
      ))
    }

@delegate:ResourceContentHash(-1_909_492_672)
internal val Res.string.premium_title: StringResource by lazy {
      StringResource("string:premium_title", "premium_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 5098, 41),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 3362, 41),
      ))
    }

@delegate:ResourceContentHash(-866_776_300)
internal val Res.string.premium_trial: StringResource by lazy {
      StringResource("string:premium_trial", "premium_trial", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 5140, 177),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 3404, 113),
      ))
    }

@delegate:ResourceContentHash(1_928_690_638)
internal val Res.string.premium_yearly: StringResource by lazy {
      StringResource("string:premium_yearly", "premium_yearly", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 5417, 38),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 3601, 30),
      ))
    }

@delegate:ResourceContentHash(-2_078_306_718)
internal val Res.string.premium_yearly_price: StringResource by lazy {
      StringResource("string:premium_yearly_price", "premium_yearly_price", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 5318, 40),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 3518, 40),
      ))
    }

@delegate:ResourceContentHash(-1_260_347_294)
internal val Res.string.premium_yearly_saving: StringResource by lazy {
      StringResource("string:premium_yearly_saving", "premium_yearly_saving", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 5359, 57),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 3559, 41),
      ))
    }

@delegate:ResourceContentHash(-1_847_089_978)
internal val Res.string.profile_block: StringResource by lazy {
      StringResource("string:profile_block", "profile_block", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 3089, 57),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 2104, 29),
      ))
    }

@delegate:ResourceContentHash(696_853_321)
internal val Res.string.profile_block_body: StringResource by lazy {
      StringResource("string:profile_block_body", "profile_block_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 2128, 406),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 1611, 202),
      ))
    }

@delegate:ResourceContentHash(-1_863_799_202)
internal val Res.string.profile_block_title: StringResource by lazy {
      StringResource("string:profile_block_title", "profile_block_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 2535, 103),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 1814, 43),
      ))
    }

@delegate:ResourceContentHash(2_092_084_856)
internal val Res.string.profile_blocked_empty_body: StringResource by lazy {
      StringResource("string:profile_blocked_empty_body", "profile_blocked_empty_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 2639, 138),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 1858, 82),
      ))
    }

@delegate:ResourceContentHash(-1_895_263_742)
internal val Res.string.profile_blocked_empty_title: StringResource by lazy {
      StringResource("string:profile_blocked_empty_title", "profile_blocked_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 2778, 123),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 1941, 59),
      ))
    }

@delegate:ResourceContentHash(1_060_604_953)
internal val Res.string.profile_blocked_on: StringResource by lazy {
      StringResource("string:profile_blocked_on", "profile_blocked_on", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 2902, 74),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 2001, 46),
      ))
    }

@delegate:ResourceContentHash(1_277_639_354)
internal val Res.string.profile_blocked_users_title: StringResource by lazy {
      StringResource("string:profile_blocked_users_title", "profile_blocked_users_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 2977, 111),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 2048, 55),
      ))
    }

@delegate:ResourceContentHash(-347_039_336)
internal val Res.string.profile_cancel: StringResource by lazy {
      StringResource("string:profile_cancel", "profile_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 3147, 38),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 2134, 30),
      ))
    }

@delegate:ResourceContentHash(-538_194_959)
internal val Res.string.profile_close: StringResource by lazy {
      StringResource("string:profile_close", "profile_close", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 3186, 41),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 2165, 29),
      ))
    }

@delegate:ResourceContentHash(1_352_997_857)
internal val Res.string.profile_edit: StringResource by lazy {
      StringResource("string:profile_edit", "profile_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 6032, 64),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 4155, 36),
      ))
    }

@delegate:ResourceContentHash(-355_288_128)
internal val Res.string.profile_edit_bio_counter: StringResource by lazy {
      StringResource("string:profile_edit_bio_counter", "profile_edit_bio_counter", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 3228, 44),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 2195, 44),
      ))
    }

@delegate:ResourceContentHash(1_889_653_214)
internal val Res.string.profile_edit_bio_label: StringResource by lazy {
      StringResource("string:profile_edit_bio_label", "profile_edit_bio_label", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 3273, 46),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 2240, 34),
      ))
    }

@delegate:ResourceContentHash(-22_176_756)
internal val Res.string.profile_edit_bio_placeholder: StringResource by lazy {
      StringResource("string:profile_edit_bio_placeholder", "profile_edit_bio_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 3320, 68),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 2275, 60),
      ))
    }

@delegate:ResourceContentHash(-1_450_069_533)
internal val Res.string.profile_edit_change_photo: StringResource by lazy {
      StringResource("string:profile_edit_change_photo", "profile_edit_change_photo", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 3486, 69),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 2413, 49),
      ))
    }

@delegate:ResourceContentHash(25_827_305)
internal val Res.string.profile_edit_change_photo_action: StringResource by lazy {
      StringResource("string:profile_edit_change_photo_action", "profile_edit_change_photo_action", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 3389, 96),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 2336, 76),
      ))
    }

@delegate:ResourceContentHash(-347_039_336)
internal val Res.string.profile_edit_date_cancel: StringResource by lazy {
      StringResource("string:profile_edit_date_cancel", "profile_edit_date_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 3556, 48),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 2463, 40),
      ))
    }

@delegate:ResourceContentHash(1_569_047_752)
internal val Res.string.profile_edit_date_clear: StringResource by lazy {
      StringResource("string:profile_edit_date_clear", "profile_edit_date_clear", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 3605, 63),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 2504, 47),
      ))
    }

@delegate:ResourceContentHash(1_181_123_422)
internal val Res.string.profile_edit_date_confirm: StringResource by lazy {
      StringResource("string:profile_edit_date_confirm", "profile_edit_date_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 3669, 53),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 2552, 45),
      ))
    }

@delegate:ResourceContentHash(-1_376_624_997)
internal val Res.string.profile_edit_date_of_birth_invalid: StringResource by lazy {
      StringResource("string:profile_edit_date_of_birth_invalid", "profile_edit_date_of_birth_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 3723, 154),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 2598, 102),
      ))
    }

@delegate:ResourceContentHash(2_101_653_852)
internal val Res.string.profile_edit_date_of_birth_label: StringResource by lazy {
      StringResource("string:profile_edit_date_of_birth_label", "profile_edit_date_of_birth_label", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 3878, 76),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 2701, 60),
      ))
    }

@delegate:ResourceContentHash(-749_199_467)
internal val Res.string.profile_edit_date_of_birth_placeholder: StringResource by lazy {
      StringResource("string:profile_edit_date_of_birth_placeholder", "profile_edit_date_of_birth_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 3955, 70),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 2762, 62),
      ))
    }

@delegate:ResourceContentHash(28_187_145)
internal val Res.string.profile_edit_date_pick: StringResource by lazy {
      StringResource("string:profile_edit_date_pick", "profile_edit_date_pick", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 4026, 62),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 2825, 46),
      ))
    }

@delegate:ResourceContentHash(-1_700_360_663)
internal val Res.string.profile_edit_discard_body: StringResource by lazy {
      StringResource("string:profile_edit_discard_body", "profile_edit_discard_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 4089, 125),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 2872, 93),
      ))
    }

@delegate:ResourceContentHash(-93_318_189)
internal val Res.string.profile_edit_discard_cancel: StringResource by lazy {
      StringResource("string:profile_edit_discard_cancel", "profile_edit_discard_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 4215, 103),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 2966, 51),
      ))
    }

@delegate:ResourceContentHash(-774_002_087)
internal val Res.string.profile_edit_discard_confirm: StringResource by lazy {
      StringResource("string:profile_edit_discard_confirm", "profile_edit_discard_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 4319, 68),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 3018, 48),
      ))
    }

@delegate:ResourceContentHash(-553_881_120)
internal val Res.string.profile_edit_discard_title: StringResource by lazy {
      StringResource("string:profile_edit_discard_title", "profile_edit_discard_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 4388, 94),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 3067, 58),
      ))
    }

@delegate:ResourceContentHash(1_130_399_260)
internal val Res.string.profile_edit_display_name_label: StringResource by lazy {
      StringResource("string:profile_edit_display_name_label", "profile_edit_display_name_label", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 4483, 83),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 3126, 55),
      ))
    }

@delegate:ResourceContentHash(-1_637_573_304)
internal val Res.string.profile_edit_display_name_placeholder: StringResource by lazy {
      StringResource("string:profile_edit_display_name_placeholder", "profile_edit_display_name_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 4567, 53),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 3182, 57),
      ))
    }

@delegate:ResourceContentHash(-1_409_450_411)
internal val Res.string.profile_edit_location_auto: StringResource by lazy {
      StringResource("string:profile_edit_location_auto", "profile_edit_location_auto", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 4828, 98),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 3359, 62),
      ))
    }

@delegate:ResourceContentHash(2_126_111_571)
internal val Res.string.profile_edit_location_auto_pending: StringResource by lazy {
      StringResource("string:profile_edit_location_auto_pending", "profile_edit_location_auto_pending", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 4621, 206),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 3240, 118),
      ))
    }

@delegate:ResourceContentHash(-626_816_397)
internal val Res.string.profile_edit_location_label: StringResource by lazy {
      StringResource("string:profile_edit_location_label", "profile_edit_location_label", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 4927, 75),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 3422, 47),
      ))
    }

@delegate:ResourceContentHash(1_124_985_476)
internal val Res.string.profile_edit_location_placeholder: StringResource by lazy {
      StringResource("string:profile_edit_location_placeholder", "profile_edit_location_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 5003, 81),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 3470, 61),
      ))
    }

@delegate:ResourceContentHash(247_434_969)
internal val Res.string.profile_edit_location_too_long: StringResource by lazy {
      StringResource("string:profile_edit_location_too_long", "profile_edit_location_too_long", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 5085, 114),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 3532, 74),
      ))
    }

@delegate:ResourceContentHash(1_853_005_251)
internal val Res.string.profile_edit_no_version: StringResource by lazy {
      StringResource("string:profile_edit_no_version", "profile_edit_no_version", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 5200, 211),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 3607, 111),
      ))
    }

@delegate:ResourceContentHash(-1_109_230_399)
internal val Res.string.profile_edit_save: StringResource by lazy {
      StringResource("string:profile_edit_save", "profile_edit_save", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 5412, 49),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 3719, 33),
      ))
    }

@delegate:ResourceContentHash(886_779_660)
internal val Res.string.profile_edit_show_birth_year: StringResource by lazy {
      StringResource("string:profile_edit_show_birth_year", "profile_edit_show_birth_year", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 5462, 96),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 3753, 56),
      ))
    }

@delegate:ResourceContentHash(-351_897_304)
internal val Res.string.profile_edit_uploading: StringResource by lazy {
      StringResource("string:profile_edit_uploading", "profile_edit_uploading", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 5559, 58),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 3810, 46),
      ))
    }

@delegate:ResourceContentHash(1_905_489_089)
internal val Res.string.profile_edit_username_available_on: StringResource by lazy {
      StringResource("string:profile_edit_username_available_on", "profile_edit_username_available_on", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 5618, 142),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 3857, 102),
      ))
    }

@delegate:ResourceContentHash(419_168_098)
internal val Res.string.profile_edit_username_label: StringResource by lazy {
      StringResource("string:profile_edit_username_label", "profile_edit_username_label", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 5761, 79),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 3960, 47),
      ))
    }

@delegate:ResourceContentHash(922_853_968)
internal val Res.string.profile_edit_username_locked: StringResource by lazy {
      StringResource("string:profile_edit_username_locked", "profile_edit_username_locked", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 5841, 136),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 4008, 92),
      ))
    }

@delegate:ResourceContentHash(-1_230_642_816)
internal val Res.string.profile_edit_username_placeholder: StringResource by lazy {
      StringResource("string:profile_edit_username_placeholder", "profile_edit_username_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 5978, 53),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 4101, 53),
      ))
    }

@delegate:ResourceContentHash(-21_711_057)
internal val Res.string.profile_error_account_gone: StringResource by lazy {
      StringResource("string:profile_error_account_gone", "profile_error_account_gone", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 6097, 98),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 4192, 74),
      ))
    }

@delegate:ResourceContentHash(-1_732_652_125)
internal val Res.string.profile_error_block: StringResource by lazy {
      StringResource("string:profile_error_block", "profile_error_block", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 6196, 111),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 4267, 67),
      ))
    }

@delegate:ResourceContentHash(-1_024_060_097)
internal val Res.string.profile_error_cancel_deletion: StringResource by lazy {
      StringResource("string:profile_error_cancel_deletion", "profile_error_cancel_deletion", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 6308, 109),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 4335, 77),
      ))
    }

@delegate:ResourceContentHash(-447_546_538)
internal val Res.string.profile_error_check_details: StringResource by lazy {
      StringResource("string:profile_error_check_details", "profile_error_check_details", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 6418, 143),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 4413, 79),
      ))
    }

@delegate:ResourceContentHash(-1_248_535_954)
internal val Res.string.profile_error_load_account: StringResource by lazy {
      StringResource("string:profile_error_load_account", "profile_error_load_account", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 6562, 126),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 4493, 82),
      ))
    }

@delegate:ResourceContentHash(491_970_583)
internal val Res.string.profile_error_load_blocked: StringResource by lazy {
      StringResource("string:profile_error_load_blocked", "profile_error_load_blocked", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 6689, 122),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 4576, 78),
      ))
    }

@delegate:ResourceContentHash(1_307_394_450)
internal val Res.string.profile_error_load_more_blocked: StringResource by lazy {
      StringResource("string:profile_error_load_more_blocked", "profile_error_load_more_blocked", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 6812, 171),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 4655, 87),
      ))
    }

@delegate:ResourceContentHash(1_591_427_828)
internal val Res.string.profile_error_load_privacy: StringResource by lazy {
      StringResource("string:profile_error_load_privacy", "profile_error_load_privacy", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 6984, 162),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 4743, 86),
      ))
    }

@delegate:ResourceContentHash(-1_943_240_508)
internal val Res.string.profile_error_load_profile: StringResource by lazy {
      StringResource("string:profile_error_load_profile", "profile_error_load_profile", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 7147, 106),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 4830, 74),
      ))
    }

@delegate:ResourceContentHash(549_548_753)
internal val Res.string.profile_error_load_public_profile: StringResource by lazy {
      StringResource("string:profile_error_load_public_profile", "profile_error_load_public_profile", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 7254, 125),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 4905, 81),
      ))
    }

@delegate:ResourceContentHash(-1_754_323_912)
internal val Res.string.profile_error_load_qr: StringResource by lazy {
      StringResource("string:profile_error_load_qr", "profile_error_load_qr", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 7380, 97),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 4987, 69),
      ))
    }

@delegate:ResourceContentHash(256_879_468)
internal val Res.string.profile_error_messages_not_allowed: StringResource by lazy {
      StringResource("string:profile_error_messages_not_allowed", "profile_error_messages_not_allowed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 7478, 146),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 5057, 98),
      ))
    }

@delegate:ResourceContentHash(884_869_239)
internal val Res.string.profile_error_open_chat: StringResource by lazy {
      StringResource("string:profile_error_open_chat", "profile_error_open_chat", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 7625, 131),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 5156, 87),
      ))
    }

@delegate:ResourceContentHash(1_134_067_431)
internal val Res.string.profile_error_prepare_edit: StringResource by lazy {
      StringResource("string:profile_error_prepare_edit", "profile_error_prepare_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 7757, 218),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 5244, 118),
      ))
    }

@delegate:ResourceContentHash(-1_215_352_676)
internal val Res.string.profile_error_save_privacy: StringResource by lazy {
      StringResource("string:profile_error_save_privacy", "profile_error_save_privacy", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 7976, 162),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 5363, 86),
      ))
    }

@delegate:ResourceContentHash(313_700_460)
internal val Res.string.profile_error_save_profile: StringResource by lazy {
      StringResource("string:profile_error_save_profile", "profile_error_save_profile", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 8139, 106),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 5450, 74),
      ))
    }

@delegate:ResourceContentHash(-1_024_409_382)
internal val Res.string.profile_error_schedule_deletion: StringResource by lazy {
      StringResource("string:profile_error_schedule_deletion", "profile_error_schedule_deletion", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 8246, 127),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 5525, 83),
      ))
    }

@delegate:ResourceContentHash(-1_820_144_526)
internal val Res.string.profile_error_session_expired: StringResource by lazy {
      StringResource("string:profile_error_session_expired", "profile_error_session_expired", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 8374, 125),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 5609, 97),
      ))
    }

@delegate:ResourceContentHash(706_908_420)
internal val Res.string.profile_error_timeout: StringResource by lazy {
      StringResource("string:profile_error_timeout", "profile_error_timeout", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 8500, 109),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 5707, 77),
      ))
    }

@delegate:ResourceContentHash(1_020_424_744)
internal val Res.string.profile_error_unblock: StringResource by lazy {
      StringResource("string:profile_error_unblock", "profile_error_unblock", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 8610, 117),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 5785, 73),
      ))
    }

@delegate:ResourceContentHash(1_935_342_453)
internal val Res.string.profile_error_update_photo: StringResource by lazy {
      StringResource("string:profile_error_update_photo", "profile_error_update_photo", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 8728, 98),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 5859, 74),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString6Resources(map: MutableMap<String, StringResource>) {
  map.put("premium_badge_description", Res.string.premium_badge_description)
  map.put("premium_badge_setting", Res.string.premium_badge_setting)
  map.put("premium_badge_setting_body", Res.string.premium_badge_setting_body)
  map.put("premium_billing_acknowledgement_pending", Res.string.premium_billing_acknowledgement_pending)
  map.put("premium_billing_already_active", Res.string.premium_billing_already_active)
  map.put("premium_billing_no_purchase", Res.string.premium_billing_no_purchase)
  map.put("premium_billing_pending", Res.string.premium_billing_pending)
  map.put("premium_billing_restored", Res.string.premium_billing_restored)
  map.put("premium_billing_unavailable", Res.string.premium_billing_unavailable)
  map.put("premium_billing_verification_failed", Res.string.premium_billing_verification_failed)
  map.put("premium_feature_limits", Res.string.premium_feature_limits)
  map.put("premium_feature_limits_body", Res.string.premium_feature_limits_body)
  map.put("premium_feature_organization", Res.string.premium_feature_organization)
  map.put("premium_feature_organization_body", Res.string.premium_feature_organization_body)
  map.put("premium_feature_personalization", Res.string.premium_feature_personalization)
  map.put("premium_feature_personalization_body", Res.string.premium_feature_personalization_body)
  map.put("premium_feature_profile", Res.string.premium_feature_profile)
  map.put("premium_feature_profile_body", Res.string.premium_feature_profile_body)
  map.put("premium_grace", Res.string.premium_grace)
  map.put("premium_intro", Res.string.premium_intro)
  map.put("premium_legal", Res.string.premium_legal)
  map.put("premium_load_error", Res.string.premium_load_error)
  map.put("premium_monthly", Res.string.premium_monthly)
  map.put("premium_monthly_price", Res.string.premium_monthly_price)
  map.put("premium_not_eligible", Res.string.premium_not_eligible)
  map.put("premium_pending", Res.string.premium_pending)
  map.put("premium_purchase_preparing", Res.string.premium_purchase_preparing)
  map.put("premium_restore", Res.string.premium_restore)
  map.put("premium_retry", Res.string.premium_retry)
  map.put("premium_sales_closed", Res.string.premium_sales_closed)
  map.put("premium_settings_entry", Res.string.premium_settings_entry)
  map.put("premium_start_trial", Res.string.premium_start_trial)
  map.put("premium_tagline", Res.string.premium_tagline)
  map.put("premium_title", Res.string.premium_title)
  map.put("premium_trial", Res.string.premium_trial)
  map.put("premium_yearly", Res.string.premium_yearly)
  map.put("premium_yearly_price", Res.string.premium_yearly_price)
  map.put("premium_yearly_saving", Res.string.premium_yearly_saving)
  map.put("profile_block", Res.string.profile_block)
  map.put("profile_block_body", Res.string.profile_block_body)
  map.put("profile_block_title", Res.string.profile_block_title)
  map.put("profile_blocked_empty_body", Res.string.profile_blocked_empty_body)
  map.put("profile_blocked_empty_title", Res.string.profile_blocked_empty_title)
  map.put("profile_blocked_on", Res.string.profile_blocked_on)
  map.put("profile_blocked_users_title", Res.string.profile_blocked_users_title)
  map.put("profile_cancel", Res.string.profile_cancel)
  map.put("profile_close", Res.string.profile_close)
  map.put("profile_edit", Res.string.profile_edit)
  map.put("profile_edit_bio_counter", Res.string.profile_edit_bio_counter)
  map.put("profile_edit_bio_label", Res.string.profile_edit_bio_label)
  map.put("profile_edit_bio_placeholder", Res.string.profile_edit_bio_placeholder)
  map.put("profile_edit_change_photo", Res.string.profile_edit_change_photo)
  map.put("profile_edit_change_photo_action", Res.string.profile_edit_change_photo_action)
  map.put("profile_edit_date_cancel", Res.string.profile_edit_date_cancel)
  map.put("profile_edit_date_clear", Res.string.profile_edit_date_clear)
  map.put("profile_edit_date_confirm", Res.string.profile_edit_date_confirm)
  map.put("profile_edit_date_of_birth_invalid", Res.string.profile_edit_date_of_birth_invalid)
  map.put("profile_edit_date_of_birth_label", Res.string.profile_edit_date_of_birth_label)
  map.put("profile_edit_date_of_birth_placeholder", Res.string.profile_edit_date_of_birth_placeholder)
  map.put("profile_edit_date_pick", Res.string.profile_edit_date_pick)
  map.put("profile_edit_discard_body", Res.string.profile_edit_discard_body)
  map.put("profile_edit_discard_cancel", Res.string.profile_edit_discard_cancel)
  map.put("profile_edit_discard_confirm", Res.string.profile_edit_discard_confirm)
  map.put("profile_edit_discard_title", Res.string.profile_edit_discard_title)
  map.put("profile_edit_display_name_label", Res.string.profile_edit_display_name_label)
  map.put("profile_edit_display_name_placeholder", Res.string.profile_edit_display_name_placeholder)
  map.put("profile_edit_location_auto", Res.string.profile_edit_location_auto)
  map.put("profile_edit_location_auto_pending", Res.string.profile_edit_location_auto_pending)
  map.put("profile_edit_location_label", Res.string.profile_edit_location_label)
  map.put("profile_edit_location_placeholder", Res.string.profile_edit_location_placeholder)
  map.put("profile_edit_location_too_long", Res.string.profile_edit_location_too_long)
  map.put("profile_edit_no_version", Res.string.profile_edit_no_version)
  map.put("profile_edit_save", Res.string.profile_edit_save)
  map.put("profile_edit_show_birth_year", Res.string.profile_edit_show_birth_year)
  map.put("profile_edit_uploading", Res.string.profile_edit_uploading)
  map.put("profile_edit_username_available_on", Res.string.profile_edit_username_available_on)
  map.put("profile_edit_username_label", Res.string.profile_edit_username_label)
  map.put("profile_edit_username_locked", Res.string.profile_edit_username_locked)
  map.put("profile_edit_username_placeholder", Res.string.profile_edit_username_placeholder)
  map.put("profile_error_account_gone", Res.string.profile_error_account_gone)
  map.put("profile_error_block", Res.string.profile_error_block)
  map.put("profile_error_cancel_deletion", Res.string.profile_error_cancel_deletion)
  map.put("profile_error_check_details", Res.string.profile_error_check_details)
  map.put("profile_error_load_account", Res.string.profile_error_load_account)
  map.put("profile_error_load_blocked", Res.string.profile_error_load_blocked)
  map.put("profile_error_load_more_blocked", Res.string.profile_error_load_more_blocked)
  map.put("profile_error_load_privacy", Res.string.profile_error_load_privacy)
  map.put("profile_error_load_profile", Res.string.profile_error_load_profile)
  map.put("profile_error_load_public_profile", Res.string.profile_error_load_public_profile)
  map.put("profile_error_load_qr", Res.string.profile_error_load_qr)
  map.put("profile_error_messages_not_allowed", Res.string.profile_error_messages_not_allowed)
  map.put("profile_error_open_chat", Res.string.profile_error_open_chat)
  map.put("profile_error_prepare_edit", Res.string.profile_error_prepare_edit)
  map.put("profile_error_save_privacy", Res.string.profile_error_save_privacy)
  map.put("profile_error_save_profile", Res.string.profile_error_save_profile)
  map.put("profile_error_schedule_deletion", Res.string.profile_error_schedule_deletion)
  map.put("profile_error_session_expired", Res.string.profile_error_session_expired)
  map.put("profile_error_timeout", Res.string.profile_error_timeout)
  map.put("profile_error_unblock", Res.string.profile_error_unblock)
  map.put("profile_error_update_photo", Res.string.profile_error_update_photo)
}
